import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { HelperService } from '../helper.service';
import { Http, Response,Headers } from '@angular/http';
import { NgForm } from '@angular/forms';
import { MessagingService } from "../messaging.service";
import {CookieService} from 'angular2-cookie/core';
import {MatSnackBar} from '@angular/material';
import { UserIdleService } from 'angular-user-idle';

@Component({
  selector: 'app-topmenu',
  templateUrl: './topmenu.component.html',
  styleUrls: ['./topmenu.component.css'],
  providers:[MessagingService,HelperService,CookieService]
})
export class TopmenuComponent implements OnInit {

 live_users:any=[];
 notify='';
 user_id;
 user_image;
 user_permissions:any=[];
 user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
datas:any=[];
awsurl;
 constructor(private msgService: MessagingService, private http: Http,private helper:HelperService,private activatedRouter:ActivatedRoute,private router:Router,private cookie: CookieService,private snackbar: MatSnackBar,private userIdle: UserIdleService) { 
  this.user_id=cookie.get('user_id');
  //this.user_image=this.helper.base_url+"storage/app/"+cookie.get('user_image');
  this.user_image=this.helper.aws_url+cookie.get('user_image');
   }

  ngOnInit() {
    this.awsurl = this.helper.aws_url;
    this.http.get(this.helper.base_url+'http/get/users/1',{ headers: this.headers })
    
    .subscribe(data => {
      this.datas = JSON.parse(data['_body']).users[0];
      
     
    });
  	 this.http.get(this.helper.base_url+'http/get/chat/live/students',{ headers: this.headers })
  
    .subscribe(data => {
     // arr=JSON.parse(data);
      this.live_users = JSON.parse(data['_body']);
     
      if(this.live_users.length>0){
      
      	this.notify='notify';
      }
          
    });
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });

  this.msgService.getPermission(this.helper.base_url);
  this.msgService.receiveMessage(); 
  this.msgService.currentMessage;

  this.msgService.currentMessage.subscribe(response  => {
    this.http.get(this.helper.base_url+'http/get/chat/live/students',{ headers: this.headers })
  
    .subscribe(data => {
    
     this.live_users = JSON.parse(data['_body']);
     
      if(this.live_users.length>0){
      
        this.notify='notify';
      }
  
          
    });
});
}
chat_url(id){
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
    this.router.navigate(["/chat/"+id]));
}
logout(){
  this.userIdle.stopWatching();
  this.cookie.removeAll();
  localStorage.removeItem('access_token');
  localStorage.removeItem('navigateroute');
  let body = new FormData();

    //return;
    body.append('token',this.user_token);
  this.http.post(this.helper.base_url+'http/logout',body,{ headers: this.headers })
  .subscribe(data => {
 
    this.snackbar.open('Logged Out Successfully', null, {
      duration:5000,
        extraClasses:'success-snackbar',
        verticalPosition:'top'
      });
   });
  
    this.router.navigate(["/login"])
    .then(() => {
      setTimeout(() => {
      window.location.reload();
    }, 2000);
    });

  
  }
}





// WEBPACK FOOTER //
// ./src/app/topmenu/topmenu.component.ts